var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDevices = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "b",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 81.32 60.19",
  width: 81.32,
  height: 60.19,
  preserveAspectRatio: "xMidYMid meet"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.6,57.66l-21,2.53c-.13-1.05.62-2.01,1.68-2.14l4.19-.51c.63-.08,1.08-.65,1-1.28l-.72-6.02,6.51-.78.72,6.02c.08.63.65,1.08,1.28,1l4.19-.51c1.05-.13,2.01.62,2.14,1.68Z",
  fill: "#206063"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.96,
  y: 14.42,
  width: 50.39,
  height: 37.36,
  rx: 2.55,
  ry: 2.55,
  transform: "translate(-3.76 3.61) rotate(-6.87)",
  fill: "#206063"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.96,
  y: 14.42,
  width: 50.39,
  height: 37.36,
  rx: 2.55,
  ry: 2.55,
  transform: "translate(-3.76 3.61) rotate(-6.87)",
  fill: "none",
  stroke: "#206063",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.27,
  y: 13.5,
  width: 50.39,
  height: 37.36,
  rx: 2.55,
  ry: 2.55,
  transform: "translate(-3.65 3.52) rotate(-6.87)",
  fill: "#f3fff4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.27,
  y: 13.5,
  width: 50.39,
  height: 37.36,
  rx: 2.55,
  ry: 2.55,
  transform: "translate(-3.65 3.52) rotate(-6.87)",
  fill: "none",
  stroke: "#298c85",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.8,
  y: -3.03,
  width: 30.42,
  height: 41.03,
  rx: 2.36,
  ry: 2.36,
  transform: "translate(29.2 65.6) rotate(-87.26)",
  fill: "#298c85"
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.8,
  y: -3.03,
  width: 30.42,
  height: 41.03,
  rx: 2.36,
  ry: 2.36,
  transform: "translate(29.2 65.6) rotate(-87.26)",
  fill: "none",
  stroke: "#298c85",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.8,
  y: -3.95,
  width: 30.42,
  height: 41.03,
  rx: 2.36,
  ry: 2.36,
  transform: "translate(30.12 64.72) rotate(-87.26)",
  fill: "#f3fff4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.8,
  y: -3.95,
  width: 30.42,
  height: 41.03,
  rx: 2.36,
  ry: 2.36,
  transform: "translate(30.12 64.72) rotate(-87.26)",
  fill: "none",
  stroke: "#41af3a",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("rect", {
  x: 53.86,
  y: 29.82,
  width: 31.54,
  height: 16.54,
  rx: 2.12,
  ry: 2.12,
  transform: "translate(20.42 100.37) rotate(-80.37)",
  fill: "#41af3a"
}), /*#__PURE__*/React.createElement("rect", {
  x: 53.86,
  y: 29.82,
  width: 31.54,
  height: 16.54,
  rx: 2.12,
  ry: 2.12,
  transform: "translate(20.42 100.37) rotate(-80.37)",
  fill: "none",
  stroke: "#41af3a",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("rect", {
  x: 54.58,
  y: 29.11,
  width: 31.54,
  height: 16.54,
  rx: 2.12,
  ry: 2.12,
  transform: "translate(21.73 100.48) rotate(-80.37)",
  fill: "#f3fff4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 54.58,
  y: 29.11,
  width: 31.54,
  height: 16.54,
  rx: 2.12,
  ry: 2.12,
  transform: "translate(21.73 100.48) rotate(-80.37)",
  fill: "none",
  stroke: "#9bcc46",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.92,48.03l-44.46,5.36c-1.54.19-2.94-.91-3.12-2.45l-.6-5.02,50.03-6.03.6,5.02c.19,1.54-.91,2.94-2.45,3.12Z",
  fill: "#298c85"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50.41,
  cy: 44.61,
  r: 1.35,
  fill: "#9bcc46"
}))));
export default SvgDevices;